import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Icon from "ol/style/Icon";
import Style from "ol/style/Style";

import ZnvHeader from "../components/ZnvHeader";
// Haltausfall Laim
import ConstructionLaimCity2028Icon from "../img/events/construction-laim-city-2028.svg";
import ConstructionIcon from "../img/events/construction.svg";
// import LandesgartenschauIcon from "../img/events/landesgartenschau.svg";
// import LandesgartenschauHeader from "../components/LandesgartenschauHeader";
import OktoberfestIcon from "../img/events/oktoberfest.svg";
import ZnvIcon from "../img/events/znv.svg";
import interpolate from "../utils/interpolate";

import type { Map } from "ol";

import type { EventConfig, EventConfigProperties } from "../configs/common";

const events: EventConfig[] = [
  // landesgartenschau;
  // new Feature({
  //   from: "2024-05-15T00:00Z",
  //   until: "2024-10-06T23:59Z",
  //   geometry: new Point([4494554, 2210623]), // Heimstetten bahnhof
  //   style: (map) => () => {
  //     const zoom = map.getView().getZoom();
  //     const scale = interpolate(zoom, [
  //       [5, 0.2],
  //       [6.5, 0.3],
  //     ]);
  //     const displacementY = interpolate(zoom, [
  //       [5, 40],
  //       [8, 60],
  //     ]);
  //     return new Style({
  //       image: new Icon({
  //         src: LandesgartenschauIcon,
  //         scale,
  //         displacement: [0, displacementY],
  //         anchor: [0.5, 1],
  //       }),
  //     });
  //   },
  //   stationUic: 8002715,
  //   stationBanner: <LandesgartenschauHeader />,
  //   onClick: () => {
  //     window.open("https://kirchheim2024.de/", "_blank");
  //   },
  // }),
  // Oktoberfest
  new Feature({
    from: "2026-09-19T00:00Z",
    geometry: new Point([2295577, 1690162]), // [1282385.7020149657, 6117672.35280045]), // Between Hbf and Hackerbrücke
    onClick: () => {
      window.open("https://www.s-bahn-muenchen.de/oktoberfest", "_blank");
    },
    style: (map: Map) => () => {
      const zoom = map.getView()?.getZoom();
      if (!zoom) {
        return;
      }

      const scale: number = interpolate(zoom, [
        [5, 0.25],
        [6.5, 0.35],
      ]);

      const displacementY = interpolate(zoom, [
        [5, -40],
        [8, -190],
      ]);
      return new Style({
        image: new Icon({
          displacement: [0, displacementY],
          scale,
          src: OktoberfestIcon,
        }),
      });
    },
    until: "2026-10-04T23:59Z",
  }),

  // Haltausfall Laim
  new Feature({
    from: "2026-08-25T00:00Z",
    geometry: new Point([1672500, 1600000]),
    style: (map: Map) => () => {
      const zoom: number = map.getView().getZoom()!;

      const scale: number = interpolate(zoom, [
        [5, 3],
        [6.5, 5],
      ]);

      const displacementY: number = interpolate(zoom, [
        [5, 60],
        [5.5, 80],
        [6, 103],
        [6.5, 135],
        [7, 170],
        [7.5, 220],
        [8, 290],
      ]);
      return new Style({
        image: new Icon({
          displacement: [0, displacementY],
          scale,
          src: ConstructionIcon,
        }),
      });
    },
    until: "2027-07-01T00:00Z",
  }),
  new Feature<Point, EventConfigProperties>({
    from: "2026-08-25T00:00Z",
    geometry: new Point([1672500, 1650000]),
    style: (map: Map) => () => {
      const zoom: number = map.getView().getZoom()!;

      // The image does not exceed the maximum width of the window on mobile devices
      const imgWidth = 80;
      const maxWidth = window.innerWidth;
      const scaleForMaxZoom = Math.min(7, maxWidth / imgWidth);
      const scale: number = interpolate(zoom, [
        [5, 1.8],
        [8, scaleForMaxZoom],
      ]);

      const displacementX: number = interpolate(zoom, [
        [5, -25],
        [5.5, -35],
        [6, -38],
        [6.5, -35],
        [7, -15],
        [7.5, 20],
        [8, 90],
      ]);

      const displacementY: number = interpolate(zoom, [
        [5, -40],
        [6, -80],
        [7, -145],
        [8, -260],
      ]);
      return new Style({
        image: new Icon({
          displacement: [displacementX, displacementY],
          scale,
          src: ConstructionLaimCity2028Icon,
        }),
      });
    },
    until: "2027-07-01T00:00Z",
  }),

  // Zukunft nah verkehr
  new Feature({
    from: "2025-09-09T00:00:00Z",
    geometry: new Point([2510000, 1750000]), // Zwischen Hauptbahnhof and Karlsplatz
    onClick: () => {
      window.open("http://zukunftnahverkehr.de/iaa", "_blank");
    },
    stationBanner: <ZnvHeader />,
    stationUic: 8000261,
    style: (map: Map) => () => {
      const zoom: number = map.getView().getZoom()!;

      const scale: number = interpolate(zoom, [
        [5, 0.2],
        [7.1, 0.5],
      ]);

      const displacementY: number = interpolate(zoom, [
        [5, 40],
        [6, 50],
        [7, 0],
      ]);
      return new Style({
        image: new Icon({
          anchor: [0.5, 1],
          displacement: [0, displacementY],
          scale: scale,
          size: [150, 150],
          src: ZnvIcon,
        }),
      });
    },
    until: "2025-09-14T23:59Z",
  }),
];
export default events;
